export default function toGoogleMapsPoint(point: number[]): google.maps.LatLng {
  if (point.length !== 2) {
    throw new Error('Points can consist of numerical values pairs only [longitude, latitude]');
  }
  return new google.maps.LatLng({ lng: point[0], lat: point[1] });
}
